/*
 * @Author: jin.li 1754611189@qq.com
 * @Date: 2025-06-26 15:22:52
 * @LastEditors: jin.li 1754611189@qq.com
 * @LastEditTime: 2025-07-10 14:06:27
 * @FilePath: \cbest-welfare-erp-h5\src\views\Product\Area\components\modalComponent.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  Form,
  Modal,
  Input,
  Upload,
} from "antd";
import { useEffect, useState } from "react";
import service from "../../../../@services";
import AreaSelect from "../../../../components/AreaSelect";

const { Dragger } = Upload;

const ModalComponent = (props) => {
  const {
    visible = false,
    title,
    onCancel = () => { },
    onOk = () => { },
    modalData = {}
  } = props;
  const [deliveryArea, setDeliveryArea] = useState([]);
  const [newAreaModelDetails, setNewAreaModelDetails] = useState([])
  const [form] = Form.useForm()

  // 表单验证
  const validate = (val) => {
    form.validateFields().then(res => {
      const newForm = { ...val, areaModelDetails: newAreaModelDetails }
      onOk(newForm)
    }).catch()
  }
  // 表单提交
  const submitFormVal = () => {
    const submitVal = Object.assign({}, form.getFieldValue())
    validate(submitVal)
  }

  const getDetail = async () => {
    const res = await service.area.getAreaDetail(modalData.id)
    const newForm = { ...res, deliveryArea: res.areaModelDetails }
    form.setFieldsValue(newForm)
    setNewAreaModelDetails(res.areaModelDetails);
    const list = res.areaModelDetails ? res.areaModelDetails.filter(item => {
      if(item.areaType === 'city') return item
    }) : []
    const newList = list.map((item)=>{
      return Number(item.areaCode)
    });
    setDeliveryArea(newList ? newList : []);
  }

  const selectAreaSelect = (value, selectedOptions) => {
    const newList = [];
    selectedOptions.forEach((item) => {
      if(item.length === 1){
        item[0].parentCode = item[0].parentAreaCode
        newList.push(item[0])
        item[0].children.forEach((item2)=>{
          if(!newList.includes(item2)){
            item2.parentCode = item2.parentAreaCode
            newList.push(item2)
          }
        })
      }else{
        if(!newList.includes(item[0])){
          item[0].parentCode = item[0].parentAreaCode
          newList.push(item[0])
          item[1].parentCode = item[1].parentAreaCode
          newList.push(item[1])
        }else{
          item[1].parentCode = item[1].parentAreaCode
          newList.push(item[1])
        }
      }
    });
    setNewAreaModelDetails(newList);
  };

  useEffect(() => {
    if (visible) {
      if (modalData.id) {
        getDetail()
      } else {
        form.resetFields()
        setDeliveryArea([])
      }
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title={title}
      centered
      closable={false}
      maskClosable={false}
      onCancel={onCancel}
      onOk={submitFormVal}
      cancelText="取消"
      okText="确认"
    >
      <Form
        form={form}
        labelCol={{ span: 5 }}
        initialValues={{
          status: 1
        }}
      >
        <Form.Item name="id" style={{ display: "none" }}>
          <></>
        </Form.Item>
        <Form.Item
          name="templateName"
          label="模板名称"
          rules={[{ required: true, message: "请输入模板名称" }]}
        >
          <Input placeholder="请输入" />
        </Form.Item>
        <Form.Item
          name="deliveryArea"
          label="可售区域"
          rules={[{ required: true, message: '请选择可售区域' }]}
        >
          <AreaSelect
            deliveryArea={deliveryArea}
            style={{ width: "100%" }}
            onChange={selectAreaSelect}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalComponent;
